import { FC } from 'react';
import { Select } from '@mantine/core';
import { Label } from 'components/CreateOrderForm';
import { ReactComponent as IconChewronDown } from '../img/iconChevronDown.svg';
import { selectStyles } from '../constants';
import styles from '../ModalAddingDocument.module.scss';

interface SelectFieldProps {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  data: { value: string; label: string }[];
  error?: string;
}

export const SelectField: FC<SelectFieldProps> = ({
  label,
  placeholder,
  value,
  onChange,
  data,
  error = '',
}) => (
  <div>
    <Label text={label} />
    <Select
      data={data}
      nothingFoundMessage='Ничего не найдено'
      placeholder={placeholder}
      styles={{
        ...selectStyles,
        input: {
          ...selectStyles.input,
          border: error ? '1px solid red' : 'none',
        },
      }}
      comboboxProps={{
        position: 'bottom',
        middlewares: { flip: false, shift: false },
        offset: 4,
      }}
      value={value || null}
      onChange={(val) => onChange(val || '')}
      withCheckIcon={false}
      rightSection={<IconChewronDown />}
      allowDeselect={false}
    />
    {error && <div className={styles.error}>{error}</div>}
  </div>
);
